<template>
  <div>
    <v-flex
      :class="benefitTypeText"
    >{{benefit.benefit_type}}</v-flex>
    <v-card>
      <v-layout row wrap justify-center fill-height align-center>
        <v-flex hover hidden-xs-only style="text-align:center;">
          <i class="material-icons" @click="goToBenefit(prev)">
            <img class="material-icons arrow-left" style="width: 15px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/angle-left-solid.svg" alt=""></img>
          </i>
        </v-flex>
        <v-flex :class="{'xs12 sm10 pl-0': $vuetify.breakpoint.smAndUp, 'xs12 sm12': $vuetify.breakpoint.smAndDown}">
          <v-layout row wrap>
            <v-flex sm12 text-16-security style="word-wrap: break-word;">
              <img
                :src=" benefit.image"
                :style="styleImageBenefit"
              />
              <v-flex 
                :class="{'sm12 pt-4 text-35-security green-security font-weight-bold': $vuetify.breakpoint.smAndUp, 'sm12 pt-2 text-21-security green-security font-weight-bold text-xs-center': $vuetify.breakpoint.smAndDown}">
                {{benefit.title}}
              </v-flex>
              <v-flex v-html="benefit.content" :class="{ 'mx-4 pr-1': $vuetify.breakpoint.smAndDown }">
              </v-flex>
            </v-flex>
            <v-flex xs12 :class="{ 'ml-3': $vuetify.breakpoint.smAndDown }">
              <v-btn
                v-if="benefit.link && benefit.is_transactional"
                color="#638d37"
                class="white--text font-weight-bold"
                :href="benefit.link"
                target="_blank"
              >Obtener beneficio</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex hover hidden-xs-only style="text-align:center;">
          <i class="material-icons" @click="goToBenefit(next)">
            <img class="material-icons arrow-right" style="width: 15px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/angle-right-solid.svg" alt=""></img>
          </i>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { mapActions} from "vuex";
export default {
  props: {
    benefit: {
      type: Object,
      required: true
    },
    prev: {
      type: Number,
      required: true
    },
    next: {
      type: Number,
      required: true
    }
  },
  computed: {
    styleImageBenefit() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'height: 284px; width: 100%; object-fit: cover; position: relative; float: left; margin-top: 16px; margin-bottom: 15px; margin-right: 23px;'
      } else {
        return "height: 284px; width: 284px; object-fit: cover; position: relative; float: left; margin-top: 16px; margin-bottom: 15px; margin-right: 23px;"
      }
    },
    benefitTypeText() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return "text-24-security font-weight-bold blue-security pb-2 pl-3 text-uppercase"
      } else {
        return "text-24-security font-weight-bold blue-security pb-2 text-uppercase"
      }
    }
  },
  methods: {
    ...mapActions("benefits",["fetchBenefit"]),
    goToBenefit(id) {
    this.fetchBenefit({id: id, full_legal_number: localStorage.getItem("view_as")});
      this.$router.push({
        name: "benefit-show",
        params: { id: id }
      });
    }
  }
};
</script>

<style>
.flecha-security {
  font-size: 50px !important;
  color: #C8C8C8;
  text-shadow: 3px 2px 6px darkgrey;
}
.arrow-left{
  filter: invert(92%) sepia(2%) saturate(4%) hue-rotate(316deg) brightness(87%) contrast(93%) drop-shadow(2px 3px 4px rgb(0 0 0 / 0.4));
  margin-bottom: 10px;
}
.arrow-right{
  filter: invert(92%) sepia(2%) saturate(4%) hue-rotate(316deg) brightness(87%) contrast(93%) drop-shadow(2px 3px 4px rgb(0 0 0 / 0.4));
  margin-bottom: 10px;
}
</style>